import { Checkbox } from "@vds/checkboxes";
import styled from "styled-components";

export const InlineCheckbox = styled(Checkbox)`
  display: inline-block;
`;
